










import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import MessageForm from "./Form.vue";
import { MessageDto } from "@/store/messages/message.interface";
import Message from "@/store/messages";

@Component({
  components: {
    "message-form": MessageForm
  }
})
export default class AppMessageCreate extends Vue {
  isLoading: boolean = false;
  error: any = "";

  async onSubmit(form: any) {
    this.error = "";
    this.isLoading = true;
    try {
      await Message.createOne(form);

      this.$router.back();
      this.isLoading = false;
      this.$toasted.success("Message Created");
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.message;
      this.$toasted.error(this.error);
    }
  }

  async onCancel() {
    this.$router.back();
  }
}
